import React, {ReactNode, useEffect} from 'react';
import {createPortal} from 'react-dom';
import {useTranslation} from 'react-i18next';
import styles from './ModalWrapper.module.css';
import {useClickOutside} from '../../hooks/useClickOutside';

type ModalWrapperProps = {
	children: ReactNode;
	handleClosePopup: () => void;
};

const ModalWrapper: React.FC<ModalWrapperProps> = ({
	handleClosePopup,
	children,
}) => {
	const {t} = useTranslation();
	const popupContainerRef = useClickOutside<HTMLDivElement>(handleClosePopup);

    useEffect(() => {
        const {body} = document;
        const scrollY = window.scrollY || window.pageYOffset;
        const previousOverflow = body.style.overflow;
        const previousPosition = body.style.position;
        const previousTop = body.style.top;
        const previousWidth = body.style.width;

        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = `-${scrollY}px`;
        body.style.width = '100%';

        return () => {
            body.style.overflow = previousOverflow || '';
            body.style.position = previousPosition || '';
            body.style.top = previousTop || '';
            body.style.width = previousWidth || '';
            window.scrollTo(0, scrollY);
        };
    }, []);

	const modalContent = (
		<div className={styles.popupWrapper}>
			<div
				role="button"
				tabIndex={0}
				ref={popupContainerRef}
				className={styles.popupContainer}
				onClick={(e) => e.stopPropagation()}
			>
				<button
					className={styles.closeButton}
					onClick={handleClosePopup}
					aria-label={t('Закрити')}
					type="button"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M18 6L6 18M6 6L18 18"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</button>
				{children}
			</div>
		</div>
	);

	return createPortal(modalContent, document.body);
};

export default ModalWrapper;
